import { DefaultModel } from "src/app/core/framework/default.model";

export class PoliticaDePrivacidade extends DefaultModel {

  nome: string;

  texto: string;

  versao: number;

}